import React from 'react';
import { Box, Button } from '@mui/material';

const ButtonTop = () => {
  return (
    <Box>
      <a href="#toTop" className="up">
        <Button
          color="error"
          variant="contained"
          texttransform="uppercase"
          sx={{
            width: '50px',
            height: '50px',
            backgroundColor: '#ff2625',
          }}
        >
          up
        </Button>
      </a>
    </Box>
  );
};

export default ButtonTop;
